import React, { Fragment, useEffect, useRef, useState } from "react";
import GptLayout from "../gptLayout";
import { useNavigate, useParams } from "react-router-dom";
import bookService from "../../services/bookService";
import { toast } from "react-toastify";
import Loader from "../reusable/Loader";
import "../../styles/chapterDetail.scss";
import ReactQuill, { Quill } from "react-quill";
import "react-quill/dist/quill.snow.css";
import { FaArrowLeft } from "react-icons/fa";
import ButtonLoader from "../reusable/ButtonLoader";
import CustomButton from "../reusable/CustomButton";
import { noChapterDetails } from "../../assets/images";
// import CustomModal from "../reusable/CustomModal";

const ChapterDetail = () => {
  const { id } = useParams();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [prevAnswer, setPrevAnswer] = useState("");
  const [answerData, setAnswerData] = useState("");
  const [updateLoading, setUpdateLoading] = useState(false);
  const [edit, setEdit] = useState(false);
  const navigate = useNavigate();

  const fetchData = async () => {
    setLoading(true);
    try {
      const res = await bookService.chapterDetailByChapterId(id);
      if (res) {
        setData(res?.data?.data?.[0]);
        setLoading(false);
      }
    } catch (error) {
      toast.error(error);
    }
  };
  useEffect(() => {
    if (id) {
      fetchData();
    }
  }, [id]);

  const handleEditAnswer = (itm) => {
    setPrevAnswer(itm?.text);
    setAnswerData(itm?.text);
    setEdit({ show: true, id: itm?._id });
  };

  const handleCancelUpdateChapterData = () => {
    setPrevAnswer("");
    // setAnswerData(itm?.text);
    setAnswerData("");
    setEdit({ show: false, id: "" });
  };

  const handleSaveChapterData = async (itm) => {
    setUpdateLoading(true);
    try {
      const res = await bookService.updateChapterData(
        itm,
        prevAnswer,
        answerData
      );
      if (res?.data?.success) {
        toast.success(res?.data?.message);
        setUpdateLoading(false);
        setPrevAnswer("");
        setAnswerData("");
        setEdit(false);
        fetchData();
      } else {
        toast.error(res?.data?.message);
        setUpdateLoading(false);
        setEdit(false);
      }
    } catch (error) {
      toast.error(error);
      setUpdateLoading(false);
    }
  };

  const CustomMindMapButton = () => {
    const button = document.createElement("button");
    button.innerText = `Mind Map 🧠`
    button.style.marginLeft = "8px";
    button.style.width = "110px";

    button.onclick = () => {
      window.open("https://tools.arcaptor.com/", "_blank");
    };
    return button;
  };

  // Extend Quill Toolbar with Custom Button
  Quill.register("modules/mindMap", function (quill, options) {
    let toolbar = quill.getModule("toolbar");
    let button = CustomMindMapButton();
    toolbar.container.appendChild(button);
  });

  const modules = {
    toolbar: {
      container: [
        [{ header: [1, 2, false] }],
        [{ font: [] }],
        [{ size: ["12px", "14px", "16px", "18px", "20px"] }],
        ["bold", "italic", "underline", "strike", "blockquote"],
        [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
        [{ color: [] }, { background: [] }],
        [{ align: [] }],

        ["link", "image", "img", "video", "data-video-id"],
        ["mindmap"],
      ],
    },
    clipboard: {
      matchVisual: false, // Important to fix the mutation error
    },
    mindMap: true,
  };
  const formats = [
    "header",
    "font",
    "size",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "check",
    "color",
    "background",
    "align",
    "link",
    "image",
    "img",
    "video",
    "data-video-id",
    "mindmap",
  ];

  const [tooltip, setTooltip] = useState({
    text: "",
    x: 0,
    y: 0,
    visible: false,
  });
  const tooltips = {
    bold: "Bold",
    italic: "Italic",
    underline: "Underline",
    strike: "Strikethrough",
    blockquote: "Blockquote",
    "list-ordered": "Ordered List",
    "list-bullet": "Bullet List",
    "list-check": "Checklist",
    "align-left": "Align Left",
    "align-center": "Align Center",
    "align-right": "Align Right",
    "align-justify": "Justify",
    link: "Insert Link",
    image: "Insert Image",
    video: "Insert Video",
    mindmap: "Mindmap",
  };
  useEffect(() => {
    const toolbar = document.querySelector(".ql-toolbar");
    if (!toolbar) return;

    const showTooltip = (event) => {
      const button = event.target.closest("button");
      if (!button) return;
      const className = button.className.replace("ql-", "").split(" ")[0];

      if (tooltips[className]) {
        const rect = button.getBoundingClientRect();
        setTooltip({
          text: tooltips[className],
          x: rect.left + window.scrollX + rect.width / 2,
          y: rect.top + window.scrollY - 30,
          visible: true,
        });
      }
    };

    const hideTooltip = () => setTooltip({ ...tooltip, visible: false });

    toolbar.addEventListener("mouseover", showTooltip);
    toolbar.addEventListener("mouseout", hideTooltip);

    return () => {
      toolbar.removeEventListener("mouseover", showTooltip);
      toolbar.removeEventListener("mouseout", hideTooltip);
    };
  }, []);

  // CHNAGE VIDEO POSITION IN EDITOR
  const dragging = useRef(false);

  useEffect(() => {
    const addDraggableToLinks = () => {
      const videoLinks = document.querySelectorAll(
        '.ql-editor a[href*="/video?videoId="]'
      );

      videoLinks.forEach((link) => {
        link.setAttribute("draggable", true);

        // Desktop Drag Start
        link.addEventListener("dragstart", (e) => {
          e.dataTransfer.setData("text/html", link.outerHTML);
          dragging.current = true;
        });

        // Mobile Touch Start
        link.addEventListener("touchstart", (e) => {
          dragging.current = true;
          e.target.classList.add("dragging");
          e.target.dataset.content = e.target.outerHTML;
        });

        // Mobile Touch End - On Drop
        link.addEventListener("touchend", (e) => {
          if (!dragging.current) return;

          const draggedContent = e.target.dataset.content;

          if (draggedContent?.includes("/video?videoId=")) {
            setAnswerData((prevData) => {
              const qlEditor = document.querySelector(".ql-editor");

              // ✅ Clear Previous Video Links (Corrected)
              const existingVideos = qlEditor.querySelectorAll(
                'a[href*="/video?videoId="]'
              );
              existingVideos.forEach((video) => video.remove());

              // ✅ Insert New Video
              const parser = new DOMParser();
              const newElement = parser.parseFromString(
                draggedContent,
                "text/html"
              ).body.firstChild;

              if (newElement) {
                const selection = window.getSelection();
                if (!selection.rangeCount) return prevData;

                const range = selection.getRangeAt(0);
                range.deleteContents();
                range.insertNode(newElement);

                range.setStartAfter(newElement);
                range.setEndAfter(newElement);
                selection.removeAllRanges();
                selection.addRange(range);
              }

              const updatedContent = qlEditor.innerHTML;
              return updatedContent;
            });
          }

          e.target.classList.remove("dragging");
          dragging.current = false;
        });
      });
    };

    setTimeout(addDraggableToLinks, 1000);

    return () => {
      const videoLinks = document.querySelectorAll(
        '.ql-editor a[href*="/video?videoId="]'
      );
      videoLinks.forEach((link) => {
        link.removeEventListener("dragstart", addDraggableToLinks);
        link.removeEventListener("touchstart", addDraggableToLinks);
        link.removeEventListener("touchend", addDraggableToLinks);
      });
    };
  }, [answerData]);

  // ================================
  // Handle Drop Event (Improved)
  // ================================
  const handleDrop = (event) => {
    event.preventDefault();
    const draggedContent = event.dataTransfer.getData("text/html");

    if (draggedContent.includes("/video?videoId=")) {
      setAnswerData((prevData) => {
        const qlEditor = document.querySelector(".ql-editor");

        // ✅ Clear Previous Video Links
        const existingVideos = qlEditor.querySelectorAll(
          'a[href*="/video?videoId="]'
        );
        existingVideos.forEach((video) => video.remove());

        // ✅ Insert New Video
        const parser = new DOMParser();
        const newElement = parser.parseFromString(draggedContent, "text/html")
          .body.firstChild;

        if (newElement) {
          const selection = window.getSelection();
          if (!selection.rangeCount) return prevData;

          const range = selection.getRangeAt(0);
          range.deleteContents();
          range.insertNode(newElement);

          range.setStartAfter(newElement);
          range.setEndAfter(newElement);
          selection.removeAllRanges();
          selection.addRange(range);
        }

        const updatedContent = qlEditor.innerHTML;
        return updatedContent;
      });
    }
  };

  const handleDragOver = (event) => {
    event.preventDefault();
    document.querySelector(".ql-editor").classList.add("drag-over");
  };

  const handleDragLeave = () => {
    document.querySelector(".ql-editor").classList.remove("drag-over");
  };

  // ADD NEW CHAPTER
  const [addChapter, setAddChapter] = useState(false);

  const handleAddNewChapter = async () => {
    setUpdateLoading(true);
    try {

      const res = await bookService.addNewChapterDirect(id, answerData);
      if (res?.data?.success) {
        toast.success(res?.data?.message);
        setUpdateLoading(false);
        setPrevAnswer("");
        setAnswerData("");
        setEdit(false);
        fetchData();
      } else {
        toast.error(res?.data?.message);
        setUpdateLoading(false);
        setEdit(false);
      }
    } catch (error) {
      toast.error(error);
      setUpdateLoading(false);
    }
  };

  return (
    <Fragment>
      {loading ? (
        <Loader />
      ) : (
        <GptLayout>
          <div className="container">
            <section className="chapter_details_list">
              <div className="pageSubheader">
                <div className="title">
                  <button onClick={() => navigate("/chat")}>
                    <FaArrowLeft />
                  </button>
                  <h2>Back To Home</h2>
                </div>
                {data?._id && (
                  <button
                    className="edit_btn"
                    onClick={
                      edit?.show && data?._id === edit?.id
                        ? () => handleCancelUpdateChapterData()
                        : () => handleEditAnswer(data)
                    }
                  >
                    {edit?.show && data?._id === edit?.id ? "Cancel" : `Edit`}
                  </button>
                )}
              </div>

              {data ? (
                <div className="chapter_details_wrapper">
                  {/* {data?.map((ele) => ( */}
                  <div className="chapter_data">
                    {edit?.show ? (
                      ""
                    ) : (
                      <>
                        {/* <div className="chapter_head">
                            <h3>Question : {ele?.question}</h3>
                          </div> */}
                        <div className="chapter_answer">
                          <p>
                            {/* Answer :<span> {ele?.answer}</span> */}
                            <span
                              dangerouslySetInnerHTML={{
                                __html: data?.text,
                              }}
                            />
                          </p>
                        </div>
                      </>
                    )}

                    {edit?.show && data?._id === edit?.id && (
                      <div className="edit_form">
                        {/* <label>Answer :</label>
                        <textarea
                          value={prevAnswer}
                          rows={5}
                          onChange={(e) => setPrevAnswer(e.target.value)}
                          placeholder="Write your answer"
                        /> */}
                        <label>Add additional data:</label>
                        <ReactQuill
                          modules={modules}
                          formats={formats}
                          value={answerData}
                          onChange={setAnswerData}
                          onDrop={handleDrop}
                          onDragOver={handleDragOver}
                          onDragLeave={handleDragLeave}
                          onTouchMove={handleDrop}
                          onTouchEnd={handleDragLeave}
                        />
                        <div className="btnGrp">
                          <button
                            onClick={() => handleCancelUpdateChapterData()}
                          >
                            Cancel
                          </button>
                          <button onClick={() => handleSaveChapterData(data)}>
                            {updateLoading ? <ButtonLoader /> : "Save"}
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                  {/* ))} */}
                </div>
              ) : addChapter ? (
                <div className="edit_form">
                  {/* <label>Answer :</label>
                        <textarea
                          value={prevAnswer}
                          rows={5}
                          onChange={(e) => setPrevAnswer(e.target.value)}
                          placeholder="Write your answer"
                        /> */}
                  <label>Add additional data:</label>
                  <ReactQuill
                    modules={modules}
                    formats={formats}
                    value={answerData}
                    onChange={setAnswerData}
                    onDrop={handleDrop}
                    onDragOver={handleDragOver}
                    onDragLeave={handleDragLeave}
                    onTouchMove={handleDrop}
                    onTouchEnd={handleDragLeave}
                  />
                  <div className="btnGrp">
                    <button onClick={() => setAddChapter(false)}>Cancel</button>
                    <button onClick={() => handleAddNewChapter(data)}>
                      {updateLoading ? <ButtonLoader /> : "Save"}
                    </button>
                  </div>
                </div>
              ) : (
                <div className="no_data">
                  <div className="content">

                    <img src={noChapterDetails} alt="no-content-chapter" />
                    <p>You havn't added any content yet</p>

                    <CustomButton
                      onClick={() => setAddChapter(true)}
                      title="Add Content"
                      className="add_cntnt"
                    />
                  </div>
                </div>
              )}
            </section>
          </div>
        </GptLayout>
      )}
    </Fragment>
  );
};

export default ChapterDetail;
